export class FolderLockNotification {
	public viewId: number;

	public folderIds: string[];

	public userName: string;

	public locked: boolean;

	public static fromJson(other: any): FolderLockNotification {
		const instance = new FolderLockNotification();
		instance.viewId = other.ViewId;
		instance.folderIds = other.FolderIds;
		instance.userName = other.UserName;
		instance.locked = other.Locked;
		return instance;
	}
}
